import {Injectable} from '@angular/core';
import {HttpClient, HttpBackend} from '@angular/common/http';
import { Observable } from 'rxjs';
import {Config} from 'src/app/models/config.interface';
import { PublicClientApplication, Configuration, LogLevel } from "@azure/msal-browser";
import { apiConstants } from 'src/app/shared/constants/endpoints';
import { configData } from 'src/config';
import { environment } from 'src/environments/environment'; 


const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

const devUrls = [
  'delightful-desert-0ae80440f.4.azurestaticapps.net',
  'bcproductsupportdev.allerganaesthetics.com'
];
const qaUrls = [
  'kind-field-0a05e4a0f.4.azurestaticapps.net',
  'bcproductsupportqa.allerganaesthetics.com'
];
const prodUrls = [
  'purple-glacier-0d4afcc1e.4.azurestaticapps.net',
  'bcproductsupport.allerganaesthetics.com'
];

const url = window.location.href;
let configBaseURL = environment.apiURL;

  const checkIsEnvironment = (urls: string []) => {
    const urlData = urls.find((listedUrl: string) => url.includes(listedUrl));
    return (urlData)?true:false;
  }

  if (checkIsEnvironment(devUrls)) {
    configBaseURL = 'https://agnapideviot.azurewebsites.net/api/';
  } else if (checkIsEnvironment(qaUrls)) {
    configBaseURL = 'https://agnapiqaiot.azurewebsites.net/api/';
  }else if (checkIsEnvironment(prodUrls)) {
    configBaseURL = 'https://agnapiprodiot.azurewebsites.net/api/';
  }

@Injectable({
  providedIn: 'root'
})

export class ConfigurationService {



  private uriAppSettings = 'configuration/configuration-data';
  public config: any;

  constructor(private http: HttpClient) {}
  

  /*
  Get application configuration settings
   */
  public getAppSettings(): Config {
    return this.config;
  }

  /*
  Get File Uploader configuration settings
   
  public getFileUploadSettings(): FileUploaderConfig {
    return this.config.fileUpload;
  }*/

  getResourceMap(): [string, string[]][] {
    const list: [string, string[]][] = [];
    list.push([environment.apiURL, environment.azureAd.scopeUri.split(',')]);
    list.push(['https://graph.microsoft.com/v1.0/me', ['user.read', 'profile']]);
    return list;
  }
  getResourceMapV2(): Map<string, Array<string> | null> {
    const protectedResourceMap = new Map([[environment.apiURL, environment.azureAd.scopeUri.split(',')], ['https://graph.microsoft.com/v1.0/me', ['user.read', 'profile']]]);
    return protectedResourceMap;
  }

  /*
  Initialize service: get configuration information from appropriate source
   */

  getApiConfig():Observable<any> {
    return this.http.get(configBaseURL+apiConstants.getConfigurationData);
  }

  async init(): Promise<void> {
  };

  async loadSecureConfig(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getApiConfig().subscribe({
        next: (res: any) => {
          this.config = { ...configData, ...res };
          resolve(this.config);
        },
        error: (error: any) => {
          reject(error);
        }
      })
    });
  }

  /*
  Get MSAL configuration for Azure Ad Authentication
   */
  public getMsalConfigurations(): Configuration {
    return {
      auth: {
        clientId: environment.azureAd.clientId,
        authority: environment.azureAd.authority,
        redirectUri: environment.azureAd.redirectUri,
        postLogoutRedirectUri: environment.azureAd.postLogoutRedirectUri,
        navigateToLoginRequestUrl: environment.azureAd.navigateToLoginRequestUrl
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
      },
      system: {
        loadFrameTimeout: 10000
      }
    };
  }

  public getMsalConfigurationsV2(): PublicClientApplication {
    return new PublicClientApplication({
      auth: {
        clientId: environment.azureAd.clientId,
        authority: environment.azureAd.authority,            
        redirectUri: environment.azureAd.redirectUri,
        postLogoutRedirectUri: environment.azureAd.postLogoutRedirectUri,
        navigateToLoginRequestUrl: environment.azureAd.navigateToLoginRequestUrl
      },
      cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
      },
      system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
            piiLoggingEnabled: false
        },
        loadFrameTimeout: 10000
      }
    });
  }
}